export const CUA_CLOUD_MACHINE_QUERY_KEY = ['rpa', 'cua-cloud', 'machine'] as const;

export const DESKTOP_TARGETS_QUERY_KEY = ['rpa', 'desktop-targets'] as const;

export const DESKTOP_TARGET_INSTANCE_ID_QUERY_KEY = [
  'desktop-target-instance-id',
] as const;

export const CUA_CLOUD_MACHINE_SUMMARY_QUERY_KEY = [
  ...CUA_CLOUD_MACHINE_QUERY_KEY,
  'summary',
] as const;

export const REFILL_BATCH_RUN_STORAGE_KEY_PREFIX = 'refill-batch-run';
